/**
 * Bada i szerokość elementu affix.
 */
(function ($, pw) {

    var v = '0.0.1.191130.01';

    pw.doc('AffixFitTo', '1.2.181011', [
        'Add attribute [data-affix-fit-to] to affix bar',
        'Optional defined source data-affix-fit-to="#menu"',
        'Example:',
        '<div data-spy="affix" data-offset-top="250" data-affix-fit-to><hr></div>'
    ]);

    pw.affixWidth = {
        isEnable: false,
        enable: function () {
            this.isEnable = true;
        },
        onResize: function () {

            if (this.enable) {

                $('[data-affix-fit-to]').width('auto');
                $('[data-affix-fit-to].affix').each(function () {

                    var ux = $(this),
                        trg = ux.data('affixFitToReference') || null;

                    if(!trg) {
                        var wr = {};
                        if(ux.data('affixFitTo')) {
                            wr = $(ux.data('affixFitTo'));
                        }
                        trg = (wr.length) ? wr : ux.parent();
                        ux.data('affixFitToReference', trg);
                    }

                    ux.width(trg.width());

                });

            }
        },
    };

    $(document)
        .ready(function () {
            if ($('[data-affix-fit-to]').length) {
                pw.affixWidth.enable();
            }
        });

    $(window)
        .on('resize', function () {
            pw.affixWidth.onResize();
        })
        .on('scroll', function () {
            pw.affixWidth.onResize();
        })
    ;

})(jQuery, window.pw);